import * as types from './actionTypes';
import classificacaoApi from '../api/classificacaoApi'


export function ListarClassificacaoSucess(classificacoes) {
    
    return { type: types.LISTAR_CLASSIFICACAO, classificacoes }
}

export function ListarClassificacao() {
    return function (dispatch) {
        return classificacaoApi.ListarClassificacao().then(resultado => {
            
            dispatch(ListarClassificacaoSucess(resultado));
        }).catch(error => {
            
            throw (error);
        });
    };
}




/** WEBPACK FOOTER **
 ** ./src/components/actions/classificacaoActions.js
 **/